import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "classes"];
import React, { Component } from 'react';
import getDisplayName from './util/getDisplayName';
import mergeClasses from '@magento/peregrine/lib/util/shallowMerge';
var classify = defaultClasses => WrappedComponent => {
  var _Class;
  return _Class = class extends Component {
    render() {
      var _this$props = this.props,
        {
          className,
          classes
        } = _this$props,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var classNameAsObject = className ? {
        root: className
      } : null;
      var finalClasses = mergeClasses(defaultClasses, classNameAsObject, classes);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
        classes: finalClasses
      }));
    }
  }, _defineProperty(_Class, "displayName", "Classify(".concat(getDisplayName(WrappedComponent), ")")), _Class;
};
export { mergeClasses };
export default classify;